import {ImpuestoDTO} from '../ImpuestoDTO';
import {TipoRetencionDTO} from '../TipoRetencionDTO';
import {TipoCFEDTO} from '../TipoCFEDTO';
import {TipoCodigoDTO} from '../TipoCodigoDTO';
import {TiposPesoDTO} from '../TiposPesoDTO';

export class DatosInicioDetallesDTO
{
  esModoEResguardo: boolean;
  indiceDetalleCFESeleccionado: number;
  columnasMostradas: string[];
  impuestosDTOs: Array<ImpuestoDTO>;
  tiposRetencionesDTOs: Array<TipoRetencionDTO>;
  tiposCFEsDTOs: Array<TipoCFEDTO>;
  sePuedeAgregarDetalleCFE: boolean;
  tiposCodigosDTOs: Array<TipoCodigoDTO>;
  tiposPesoDTOs: Array<TiposPesoDTO>;
}
